import React from "react";
import default_profile_img from "/src/assets/img/profile_avatar/0.avif";
import coin from "../assets/img/icons/coin.avif";
import { Link } from "react-router-dom";
const getAuthState = () => {
    if (typeof window === "undefined") {
        return { isLoggedIn: false, user: null };
    }

    const token = localStorage.getItem("token");
    const rawUser = localStorage.getItem("user");
    let user = null;

    if (rawUser) {
        try {
            user = JSON.parse(rawUser);
        } catch {
            user = null;
        }
    }

    return { isLoggedIn: Boolean(token), user };
};

const formatCoinBalance = (value) => {
    const parsed = Number(value);
    // if (!Number.isFinite(parsed)) {
    //     return "0";
    // }
    // return parsed.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    return parsed;
};

export default function Header() {
    const [authState, setAuthState] = React.useState(getAuthState);

    React.useEffect(() => {
        const syncAuthState = () => {
            setAuthState(getAuthState());
        };

        syncAuthState();
        window.addEventListener("auth:updated", syncAuthState);
        window.addEventListener("storage", syncAuthState);

        return () => {
            window.removeEventListener("auth:updated", syncAuthState);
            window.removeEventListener("storage", syncAuthState);
        };
    }, []);

    const openLoginModal = (e) => {
        e.preventDefault();
        if (window.UIkit && typeof window.UIkit.modal === "function") {
            window.UIkit.modal("#modal-login", { container: false }).show();
        }
    };

    const handleLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.clear();
        window.dispatchEvent(new CustomEvent("auth:updated"));
        // window.location.reload();
        const path = window.location.pathname;
        const protectedRoutes = ["/",""];

        if (protectedRoutes.some((r) => path.startsWith(r))) {
            // window.location.replace("/"); // or /login
        } else {
            window.location.reload();
        }

    };

    const user = authState.user || {};
    const nickname = user?.nickname || user?.name || user?.username || (user?.email ? user.email.split("@")[0] : "Player");
    const coinBalance = formatCoinBalance(user?.coin_balance ?? user?.platform_coin_balance ?? user?.coins ?? 0);
    const avatarSrc =
    user?.img_url ||
    (user?.profile_pic ? `/assets/img/profile_avatar/${user.profile_pic}.avif` : null) ||
    default_profile_img;

    return (
        <>
            <style>
                {`
                    .menu-btn .toggle-menu-button-icon span {
                        background-color: #e4e4e4 !important;
                        border-color: #e4e4e4 !important;
                    }

                    .header-user-menu {
                        margin-top: 0 !important;
                        margin-bottom: 0 !important;
                        max-width: 100%;
                    }

                    .page-header__action .header-user-pill {
                        display: inline-flex;
                        align-items: center;
                        gap: 10px;
                        min-height: 44px;
                        padding: 5px 10px 5px 6px;
                        border-radius: 999px;
                        max-width: min(320px, 48vw);
                        border: 1px solid #ff810e;
                        background: rgba(7, 11, 23, 0.7);
                        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.24);
                        transition: transform 0.2s ease, box-shadow 0.2s ease;
                        opacity: 1;
                    }

                    .page-header__action .header-user-pill:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
                    }

                    .header-user-pill__avatar {
                        width: 45px;
                        height: 45px;
                        border-radius: 50%;
                        object-fit: cover;
                        border: 1px solid rgba(255, 255, 255, 0.8);
                        margin-right: 0;
                    }

                    .header-user-pill__meta {
                        display: flex;
                        flex-direction: column;
                        line-height: 1.05;
                        min-width: 0;
                        overflow: hidden;
                    }

                    .header-user-pill__nick {
                        font-size: 12px;
                        font-weight: 500;
                        color: rgba(255, 255, 255, 0.72);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .page-header__content .uk-subnav-pill > * > :first-child {
                    padding: 5px 5px;
                    }

                    .header-user-pill__coins {
                        font-size: 18px;
                        font-weight: 700;
                        color: #ffffff;
                        line-height:26px;
                        letter-spacing: -0.01em;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .header-user-pill__caret {
                        flex: 0 0 auto;
                        color: #ff9d3b;
                    }

                    .header-login-btn {
                        position: relative;
                        overflow: hidden;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        height: 44px;
                        padding: 0 18px;
                        border-radius: 999px;
                        border: 1px solid rgba(255, 255, 255, 0.24);
                        background: linear-gradient(120deg, #ff5500, #ff810e, #ff3d3d);
                        background-size: 220% 220%;
                        color: #fff;
                        font-weight: 700;
                        font-size: 13px;
                        text-decoration: none;
                        letter-spacing: 0.01em;
                        box-shadow: 0 10px 24px rgba(255, 129, 14, 0.28);
                        animation: loginGradientShift 4s ease infinite;
                        transition: transform 0.2s ease, box-shadow 0.2s ease;
                        white-space: nowrap;
                        max-width: min(220px, 45vw);
                    }

                    .header-login-btn::after {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: -40%;
                        width: 40%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.38), transparent);
                        transform: skewX(-18deg);
                        animation: loginSheen 2.2s ease-in-out infinite;
                    }

                    .header-login-btn:hover {
                        color: #fff;
                        text-decoration: none;
                        transform: translateY(-1px) scale(1.02);
                        box-shadow: 0 14px 30px rgba(255, 129, 14, 0.38);
                    }

                    @media (max-width: 991px) {
                        .page-header__action {
                            min-width: 0;
                        }

                        .page-header__action .header-user-pill {
                            max-width: min(270px, 44vw);
                        }

                        .header-user-pill__coins {
                            font-size: 16px;
                        }
                    }

                    @media (max-width: 767px) {
                        .page-header__action .header-user-pill {
                            min-height: 38px;
                            max-width: min(220px, 43vw);
                            gap: 7px;
                            padding: 4px 8px 4px 5px;
                        }

                        .header-user-pill__avatar {
                            width: 24px;
                            height: 24px;
                        }

                        .header-user-pill__nick {
                            font-size: 9px;
                        }

                        .header-user-pill__coins {
                            font-size: 14px;
                        }

                        .header-login-btn {
                            height: 38px;
                            padding: 0 12px;
                            font-size: 11px;
                            max-width: min(180px, 40vw);
                        }
                    }

                    @media (max-width: 575px) {
                        .page-header__action .header-user-pill {
                            max-width: min(170px, 40vw);
                            padding-right: 6px;
                        }

                        .header-user-pill__caret {
                            display: none;
                        }

                        .header-user-pill__coins {
                            font-size: 12px;
                        }

                        .header-login-btn {
                            max-width: min(150px, 36vw);
                            padding: 0 10px;
                        }
                    }

                    @keyframes loginGradientShift {
                        0% { background-position: 0% 50%; }
                        50% { background-position: 100% 50%; }
                        100% { background-position: 0% 50%; }
                    }

                    @keyframes loginSheen {
                        0% { left: -45%; }
                        100% { left: 130%; }
                    }

                `}
            </style>
            <header className="page-header">
                <div className="page-header__inner">
                    <div className="page-header__sidebar">

                        <div className="page-header__menu-btn">

                            <button className="menu-mobile-button visible-xs-block js-toggle-mobile-slidebar toggle-menu-button menu-btn">
                                <span className="toggle-menu-button-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>
                        <div className="page-header__logo">
                        <Link to={'/'}><span className="page-header__logo_text text-white" style={{cursor:"pointer"}}> CGES.CLUB</span></Link></div>
                    </div>
                    <div className="page-header__content">
                        <div className="page-header__search">
                            {/* <div className="search">
                                <div className="search__input"><i className="ico_search"></i><input type="search" name="search" placeholder="Search"/></div>
                                <div className="search__btn"><button type="button"><i className="ico_microphone"></i></button></div>
                            </div> */}
                        </div>
                        <div className="page-header__action">

                            {/* <ul className="uk-subnav uk-nav-lang  uk-subnav-pill" uk-margin={"true"}>

                                <li>
                                    <a href="#">
                                        <img src="assets/img/united-kingdom.png" alt="profile" className="profile"/>
                                        English
                                        <span uk-icon="icon: triangle-down"></span>

                                    </a>
                                    <div uk-dropdown="mode: hover">
                                        <ul className="uk-nav uk-dropdown-nav">
                                            <li><a href="#"> <img src="assets/img/germany.png" alt="profile" className="profile"/>Germany</a></li>
                                            <li><a href="#"> <img src="assets/img/italy.png" alt="profile" className="profile"/>Italy</a></li>

                                        </ul>
                                    </div>
                                </li>
                            </ul> */}



                            {/* <a className="action-btn" href="06_chats.html"><i className="ico_message"></i><span className="animation-ripple-delay1"></span></a>
                            <a className="action-btn" href="07_friends.html"><i className="ico_notification"></i><span className="animation-ripple-delay2"></span></a> */}

                            {authState.isLoggedIn ? (
                                <ul className="uk-subnav uk-subnav-pill header-user-menu" uk-margin={"true"} >
                                    <li style={{ margin: "0px", paddingBottom:'0px' }}>
                                        <a href="#" className="header-user-pill">
                                            <img src={avatarSrc} alt="profile" className="header-user-pill__avatar" />
                                            <span className="header-user-pill__meta">
                                                <span className="header-user-pill__nick" style={{textOverflow:"ellipsis",width:"60px"}}>{nickname}</span>
                                                <span className="header-user-pill__coins"><img src={coin} width={15} alt="coin" style={{marginTop:'-3px'}}/>&nbsp;{coinBalance}</span>
                                            </span>
                                            <span className="header-user-pill__caret" uk-icon="icon: triangle-down"></span>
                                        </a>
                                        <div uk-dropdown="mode: click" style={{left:'0px'}}>
                                            <ul className="uk-nav uk-dropdown-nav" >
                                                <li><Link to="/profile">My account</Link></li>
                                                {/* <li><a href="#">My Password</a></li> */}
                                                <li className="uk-nav-divider"></li>
                                                <li><a href="#" onClick={handleLogout}>Log Out</a></li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            ) : (
                                <a href="#modal-login" onClick={openLoginModal} className="header-login-btn">
                                    Login Now
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}
